import defaultAction from 'services/Search/strategies/search-bar-actions/defaultAction'
import ISearchBarAction from 'services/Search/strategies/search-bar-actions/interface'
import responsiveAction from 'services/Search/strategies/search-bar-actions/responsiveAction'

function searchBarAction({
  type,
  defaultAction: actions,
}: ISearchBarAction): Function {
  const actionMapper = {
    default: defaultAction,
    responsive: responsiveAction,
  }

  return actionMapper[type]({ defaultAction: actions })
}

export default searchBarAction
